// 消息列表板块
const NewsListIndex = resolve =>
  require(['../../../views/newsList/index'], resolve)
const NewsListNotice = resolve =>
  require(['../../../views/newsList/notice'], resolve)
const NewsListBespeak = resolve =>
  require(['../../../views/newsList/bespeak'], resolve)
const NewsListReply = resolve =>
  require(['../../../views/newsList/reply'], resolve)
const NewsListSystemNotification = resolve =>
  require(['../../../views/newsList/systemNotification'], resolve)

//平台消息推送列表
const pushMessageList = resolve =>
  require(['../../../views/newsList/pushMessageList'], resolve)
export default [
  // 首页
  {
    path: '/newsList-index',
    component: NewsListIndex,
    name: 'NewsListIndex'
  },
  {
    path: '/newsList-notice',
    component: NewsListNotice,
    name: 'NewsListNotice'
  },
  {
    path: '/newsList-bespeak',
    component: NewsListBespeak,
    name: 'NewsListBespeak'
  },
  {
    path: '/newsList-reply',
    component: NewsListReply,
    name: 'NewsListReply'
  },
  {
    path: '/newsList-systemNotification',
    component: NewsListSystemNotification,
    name: 'NewsListSystemNotification'
  },
  {
    path: '/push-message-list',
    component: pushMessageList,
    name: 'pushMessageList',
    meta: {
      pageName: '推送消息',
      business: '平台'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/page/newsList/index.js